import { gql } from '@provision/graphql-client';

export const RECORD_FOLDER_FRAGMENT = gql`
  fragment RecordFolderFields on RecordFolder {
    id
    recordFolderId
    name
    icon
    area
    partnerId
    userId
    isPrivate
  }
`;
